import {forwardRef} from 'react';
import ReviewAndApprove from '../../review-and-approve/ReviewAndApprove';
import {IEditProtocolChildRef} from '../../header/ReviewHeader';

interface IEditProtocolIntelligence {
  setIsEditingProtocol: React.Dispatch<React.SetStateAction<boolean>>;
}
const EditProtocolIntelligence = forwardRef<
  IEditProtocolChildRef,
  IEditProtocolIntelligence
>(({setIsEditingProtocol}, functionRef) => {
  return (
    <ReviewAndApprove
      setIsEditingProtocol={setIsEditingProtocol}
      ref={functionRef}
    />
  );
});

export default EditProtocolIntelligence;
